import script from "./JSONImport.vue?vue&type=script&lang=ts&setup=true"
export * from "./JSONImport.vue?vue&type=script&lang=ts&setup=true"

import "./JSONImport.vue?vue&type=style&index=0&id=0d7ce102&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7ce102"]])

export default __exports__